import { useOpenSearchContext } from './useOpenSearchContext';

const useOpenSearch = () => {
  const { refetch, status, isFetching, isLoading, totalHits } =
    useOpenSearchContext();

  return { status, refetch, isFetching, isLoading, totalHits };
};

export { useOpenSearch };
